<template>
  <div>
    <section>
      <div class="roadmap">
        <div class="roadmap-details">
          <h1>Roadmap to Launch!</h1>
          <a href="#storefront">
            <div class="roadmap-card">
              <div class="roadmap-card-left">
                <p style="margin-right: 20px; padding-left: 1.4rem">1</p>
              </div>
              <div class="roadmap-card-right">
                <h6>Build your storefront</h6>
              </div>
            </div>
          </a>
          <a href="#timeline">
            <div class="roadmap-card">
              <div class="roadmap-card-left">
                <p style="padding-left: 1.2rem">2</p>
              </div>
              <div class="roadmap-card-right">
                <h6>Formulate your strategy</h6>
              </div>
            </div>
          </a>
          <a href="#launch">
            <div class="roadmap-card">
              <div class="roadmap-card-left">
                <p style="padding-left: 1.2rem">3</p>
              </div>
              <div class="roadmap-card-right">
                <h6>Launch!</h6>
              </div>
            </div>
          </a>
        </div>
        <div></div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.roadmap-card-left p {
  display: flex;
  text-align: center;
  justify-content: center;
}

section {
  width: 100%;
  padding: 10rem 2rem;
  text-align: center;

  background-image: url('/img/roadmap-wallpaper.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: scroll;
}

.roadmap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 60rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.roadmap-details h1 {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.7rem;
  font-weight: 600;
  color: #25a4e1;
}

.roadmap-details {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.roadmap-details a {
  text-decoration: none;
}

.roadmap-card {
  width: 100%;
  display: flex;
  border-radius: 5px;
  align-items: center;
  gap: 0.5rem;
  height: 10vh;
  cursor: pointer;
  background-color: #25a4e1;
  transition: 0.2s ease-in;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.roadmap-card:hover {
  background-color: #1881b3;
}

.roadmap-card-left p {
  display: flex;
  color: white;
  padding: 10px;
  font-size: 3rem;
  font-weight: 700;
  margin: 1rem;
  text-align: right;
}

.roadmap-card-right h6 {
  font-size: 1.3rem;
  color: white;
  margin: 0;
}

@media only screen and (max-width: 900px) {
  .roadmap {
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 800px) {
  section {
    padding: 2rem;
  }

  .roadmap-details {
    grid-template-columns: 1fr;
  }

  .roadmap-card {
    max-width: 40rem;
  }

  section {
    background-position: left;
  }

  .roadmap-card p {
    font-size: 2rem;
  }

  .roadmap-card-right h6 {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 600px) {
  .roadmap-card-left p {
    padding-left: 1rem;
  }
}
</style>
